import useTranslation from '../../../hooks/useTranslation'
import Container from '../../../UI/Container/Container'
import arrow from '../../../../assets/image/arrow.png'
import Shadow from '../../../UI/Shadow/Shadow'

const ContactForm: React.FC<{}> = () => {
  const t = useTranslation()

  return (
    <div className="bg-beige py-16 relative">
      <Shadow bottom className="h-4" />
      <Container>
        <div className="flex flex-row gap-10 md:gap-32 items-center">
          <div className="w-1/2 md:w-8/12">
            <div className="text-sm md:text-xl font-bold uppercase">{t.contact.headline}</div>
            <div className="text-xs md:text-lg">{t.contact.text}</div>
          </div>
          <div className="w-1/2 md:w-4/12">
            <a href={`mailto:${t.contact.mail}`} className="flex items-center gap-2">
              <img src={arrow} className="w-2 md:w-3" alt="" />
              <div className="text-xs md:text-lg font-bold text-black">{t.contact.mail}</div>
            </a>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default ContactForm
